import type { AuthConfig } from '@pesto/features';

import { AdminDebugger, AuthProvider } from '@pesto/features';
import { UiLibProvider } from '@pesto/ui/providers/UiLibProvider';

import './App.css';
import { FloatingDevTools } from './components/FloatingDevTools/FloatingDevTools';
import { routes } from './constants/routes';
import { colorSchemes } from './constants/themes';
import { ModalContainer } from './modals/ModalContainer';
import { AuthManageProvider } from './providers/AuthManageProvider';
import { RouterProvider } from './providers/RouterProvider';

const authConfig: AuthConfig = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientID: import.meta.env.VITE_SC_AUTH0_CLIENT_ID || '',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
  redirectUri: window && window.location.origin + routes.loginCallback,
};

function App() {
  return (
    <AuthProvider config={authConfig}>
      <AuthManageProvider>
        <UiLibProvider
          themeProviderProps={{
            overrideTheme: 'light',
            colorSchemes,
          }}
        >
          <FloatingDevTools />
          <ModalContainer />
          <AdminDebugger content={<div>Hello</div>} />
          <RouterProvider />
        </UiLibProvider>
      </AuthManageProvider>
    </AuthProvider>
  );
}

export default App;
